import React, { Component, Fragment } from "react";
import { withGetScreen } from "react-getscreen";
import { Alert } from "@maxmilhas/hangar-components-atomic";
import { addDecimalPoints, formatCurrency } from "../../../../../../js/shared/utils";
import Loading from "../../../../../shared/Loading/Loading";
import { formatDateToPortugueseFormat } from "../../../../shared/utils";
import SaleDetailsInstallmentPanel from "../../../sale-details/SaleDetailsInstallmentsPanel";
import { PAYMENT_SCHEDULE_TYPE } from "../../consts";
import { capitalize, getIcon, getStatus, isFrozenPayment, isResale } from "../../helpers";
import CardTag from "../../../atoms/card-tag";

class ItemListFidelityPlanForwardPayment extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
		};
	}

	render() {
		// AQS-4769 - Retirar parcelas da tela de Minhas Vendas - Temporário
		// const showSaleOutgoings = !!this.props.sale.outgoings?.result?.length;
		const showSaleOutgoings = false;
		const frozenPayment = isFrozenPayment(this.props.sale.status);

		return (
			<Fragment>
				<div
					className={`item-list-fidelity-plan col-xs-16
						${this.props.open ? "item-list-fidelity-plan__open-card" : ""}
						${getStatus(this.props.sale.status)}
					`}
				>
					<div className="item-list-fidelity-plan__card">
						<div
							className={`item-list-fidelity-plan__block 
								${getStatus(this.props.sale.status)}
							`}
						>
							{frozenPayment && (
								<Alert
									icon="icon-max-communication-doubt"
									className="payment-guarantee-style payment-suspended"
								>
									O pagamento desta venda está congelado devido ao processo de Recuperação Judicial.
									Liberaremos após plano de ação aprovado e executado.
								</Alert>
							)}
							<CardTag show color="card-tag-custom scheduled">
								Agendado
							</CardTag>
							<ul
								className="item-list-fidelity-plan__block--ul"
								style={{ opacity: !!this.state.loading || !!this.props.loading ? "0.4" : "1" }}
							>
								<li className="item-list-fidelity-plan__block--li has-border children-1">
									ID Negociação:
									<span>{this.props.sale.negotiationId}</span>
								</li>
								<li className="item-list-fidelity-plan__block--li has-border children-2">
									Data Negociação: <span>{formatDateToPortugueseFormat(this.props.sale.saleDate)}</span>
								</li>
								<li className="item-list-fidelity-plan__block--li has-border children-3">
									Prazo: <span>{this.props.sale.paymentDeadline ? `${this.props.sale.paymentDeadline} ${PAYMENT_SCHEDULE_TYPE[this.props.sale.paymentScheduleType]}` : ''}</span>
								</li>
								{!isResale(this.props.sale.status) && (
									<li className={`item-list-fidelity-plan__block--li has-border children-3`}>
										Pagamento: {frozenPayment ? (
											<span>A definir</span>
										) : (
											<span>
											{!!this.props.sale.outgoings?.result?.length
												? `${this.props.sale.outgoings?.result?.length} parcelas `
												: formatDateToPortugueseFormat(this.props.sale.paymentDate)}{" "}
											<i className={getIcon(this.props.sale.status)} />
										</span>
										)}
									</li>
								)}
								<li className={`item-list-fidelity-plan__block--li has-border children-3`}>
									Status:
									<span>
										{capitalize(getStatus(this.props.sale.status, true))}
									</span>
								</li>
								<li className={`item-list-fidelity-plan__block--li ${isResale(this.props.sale.status) && 'has-border'} children-1`}>
									{addDecimalPoints(this.props.sale.miles)} milhas:
									<span>
										{!!this.props.sale.outgoings?.result?.length
											? formatCurrency(this.props.sale.total)
											: formatCurrency(this.props.sale.totalToRecive)}
									</span>
								</li>
								<li className={`item-list-fidelity-plan__block--li ${isResale(this.props.sale.status) && 'has-border'} children-2`}>
									1.000 milhas: <span>{formatCurrency(this.props.sale.price)}</span>
								</li>
								<li className="item-list-fidelity-plan__block--li children-3">
									Prog. Fidelidade: <span>{this.props.sale.fidelityName}</span>
								</li>
								<li className="item-list-fidelity-plan__block--li children-3">
									Login Fidelidade: <span>{this.props.sale.fidelityLogin}</span>
								</li>
							</ul>
						</div>

						{showSaleOutgoings &&
							<div className="item-list-fidelity-plan__details-button">
								<button
									className="btn btn-icon"
									onClick={e => this.props.click(e, this.props.sale.id, this.props.sale.status)}
									data-action="item-list-fidelity-plan-expand-collapse"
								>
									<i className={this.props.open ? "icon-arrow-up" : "icon-arrow-down"} />
								</button>
							</div>
						}
					</div>
					<div
						className="sale-details-flight-panel"
						style={{ maxHeight: !!this.props.open ? "1000px" : "0px" }}
					>
						{!!this.props.open && showSaleOutgoings && (
							<SaleDetailsInstallmentPanel installments={this.props.sale.outgoings} />
						)}
					</div>
					{(!!this.state.loading || !!this.props.loading) && <Loading />}
				</div>
			</Fragment>
		);
	}
}
export default withGetScreen(ItemListFidelityPlanForwardPayment, {
	mobileLimit: 468, // TODO Fix screen vars
	tabletLimit: 768, // TODO Fix screen vars
	shouldListenOnResize: true
});
